<template><div></div></template>
<script setup lang="ts">
definePage({
  redirect: { name: '/[[space]]/kb/' },
})
</script>
